import styled from 'styled-components';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { riseIn } from '@shared/theme/animations';

const Wrap = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(7)};
  animation: ${riseIn} 420ms ${({ theme }) => theme.motion.easeOut};
`;

const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;

  & .accent {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 800;
  }
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 15px;
  margin-top: ${({ theme }) => theme.spacing(2)};
  max-width: 760px;
`;

const Tabs = styled.nav`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(5)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

const TabLink = styled(Link)<{ $active: boolean }>`
  position: relative;
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.text.primary : theme.colors.text.secondary};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.radius.md} ${({ theme }) => theme.radius.md} 0 0;
  transition:
    color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut},
    background ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut};

  &::after {
    content: '';
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: -1px;
    height: 2px;
    background: ${({ theme }) => theme.colors.primary};
    transform: scaleX(${({ $active }) => ($active ? 1 : 0)});
    transform-origin: center;
    transition: transform ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.spring};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.surface};
  }
`;

const TABS = [
  { path: '/admin', label: 'Обзор', end: true },
  { path: '/admin/users', label: 'Пользователи', end: false },
  { path: '/admin/services', label: 'Службы', end: false },
  { path: '/admin/system', label: 'Сервер', end: false },
  { path: '/admin/announcements', label: 'Обновления', end: false },
  { path: '/admin/assistant', label: 'Помощник', end: false },
  { path: '/admin/audit', label: 'Журнал', end: false },
];

export function AdminLayout() {
  const location = useLocation();
  return (
    <Wrap>
      <Header>
        <Title>
          ОСНОВА<span className="accent">.Админ</span>
        </Title>
        <Subtitle>
          Управление пользователями, ролями, контроль использования AI-агентов и нагрузки на сервер.
        </Subtitle>
        <Tabs>
          {TABS.map((t) => {
            const active = t.end
              ? location.pathname === t.path
              : location.pathname.startsWith(t.path);
            return (
              <TabLink key={t.path} to={t.path} $active={active}>
                {t.label}
              </TabLink>
            );
          })}
        </Tabs>
      </Header>
      <Outlet />
    </Wrap>
  );
}
